import SettingFrame from "../../../../components/@settings/SettingFrame";
import ListAuditTrails from "../../../../components/@audit/ListAuditTrails";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function AuditTrailsPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ListAuditTrails
                routeType={routeType}
            />
        </SettingFrame>
    )
}       